export const createDropdownOption = (index = 0, option = {}) => ({
  id: option.id || `option-${index + 1}`,
  label: option.label ?? option.value ?? `Option ${index + 1}`,
  value: option.value ?? option.label ?? `option_${index + 1}`,
  isCorrect: Boolean(option.isCorrect),
});

export const createDropdownDefinition = (index = 0, dropdown = {}) => ({
  id: dropdown.id || `dropdown-${index + 1}`,
  name: dropdown.name || `Dropdown ${index + 1}`,
  allowMultiple: Boolean(dropdown.allowMultiple),
  options: Array.isArray(dropdown.options)
    ? dropdown.options.map((option, optionIndex) =>
        createDropdownOption(optionIndex, option)
      )
    : [createDropdownOption()],
});

export const normalizeDropdownLibrary = (dropdowns = []) =>
  Array.isArray(dropdowns)
    ? dropdowns.map((dropdown, index) =>
        createDropdownDefinition(index, dropdown)
      )
    : [];

export const dropdownLibraryReducer = (state, action) => {
  switch (action.type) {
    case "HYDRATE": {
      const nextState = normalizeDropdownLibrary(action.payload);
      const currentSerialized = JSON.stringify(state);
      const nextSerialized = JSON.stringify(nextState);
      return currentSerialized === nextSerialized ? state : nextState;
    }
    case "ADD_DROPDOWN": {
      const nextDropdown = createDropdownDefinition(state.length);
      return [...state, nextDropdown];
    }
    case "REMOVE_DROPDOWN": {
      const index = action.index;
      if (index == null || index < 0 || index >= state.length) {
        return state;
      }
      return state.filter((_, idx) => idx !== index);
    }
    case "UPDATE_DROPDOWN": {
      const { index, updates } = action;
      if (
        index == null ||
        index < 0 ||
        index >= state.length ||
        !updates ||
        typeof updates !== "object"
      ) {
        return state;
      }
      return state.map((dropdown, idx) =>
        idx === index ? { ...dropdown, ...updates } : dropdown
      );
    }
    case "ADD_DROPDOWN_OPTION": {
      const { dropdownIndex } = action;
      if (
        dropdownIndex == null ||
        dropdownIndex < 0 ||
        dropdownIndex >= state.length
      ) {
        return state;
      }
      return state.map((dropdown, idx) => {
        if (idx !== dropdownIndex) {
          return dropdown;
        }
        const nextOptions = [
          ...dropdown.options,
          createDropdownOption(dropdown.options.length),
        ];
        return { ...dropdown, options: nextOptions };
      });
    }
    case "UPDATE_DROPDOWN_OPTION": {
      const { dropdownIndex, optionIndex, updates } = action;
      if (
        dropdownIndex == null ||
        dropdownIndex < 0 ||
        dropdownIndex >= state.length ||
        optionIndex == null ||
        optionIndex < 0 ||
        !updates ||
        typeof updates !== "object"
      ) {
        return state;
      }
      const dropdown = state[dropdownIndex];
      if (!dropdown || optionIndex >= dropdown.options.length) {
        return state;
      }
      const nextOptions = dropdown.options.map((option, idx) =>
        idx === optionIndex ? { ...option, ...updates } : option
      );
      return state.map((item, idx) =>
        idx === dropdownIndex ? { ...item, options: nextOptions } : item
      );
    }
    case "REMOVE_DROPDOWN_OPTION": {
      const { dropdownIndex, optionIndex } = action;
      if (
        dropdownIndex == null ||
        dropdownIndex < 0 ||
        dropdownIndex >= state.length ||
        optionIndex == null ||
        optionIndex < 0
      ) {
        return state;
      }
      const dropdown = state[dropdownIndex];
      if (!dropdown || optionIndex >= dropdown.options.length) {
        return state;
      }
      const nextOptions = dropdown.options.filter((_, idx) => idx !== optionIndex);
      return state.map((item, idx) =>
        idx === dropdownIndex
          ? {
              ...item,
              options: nextOptions.length ? nextOptions : [createDropdownOption()],
            }
          : item
      );
    }
    default:
      return state;
  }
};

